import { Grid, makeStyles, Typography } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";

const useStyles = makeStyles((theme) => ({
  row: {
    padding: theme.spacing(1),
  },
}));

export const Base = ({
  building,
  headerTitle,
  secondButton,
  data,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <Box>
      <Header
        title={headerTitle}
        hideTenants
        building={building}
        onClose={onClose}
      />

      <InfoBox color="#FAF9FA" style={{ margin: 0 }}>
        {data.part1.map((row, index) => (
          <Grid
            className={classes.row}
            key={index}
            container
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h4">{row.text}</Typography>
            <Typography variant="h4">{row.value}</Typography>
          </Grid>
        ))}
      </InfoBox>
      <InfoBox color="#E7FCDC" style={{ margin: 0 }}>
        {data.part2.map((row, index) => (
          <Grid
            className={classes.row}
            key={index}
            container
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h3">{row.text}</Typography>
            <Typography variant="h3">{row.value}</Typography>
          </Grid>
        ))}
      </InfoBox>

      <GroupButton buttons={[{ text: "SHARE" }, { text: secondButton }]} />
    </Box>
  );
};
